<template>
<div class="page">
    <Header></Header>
    <b-container class="page-hero-holder">
        <PageImage :image="image" :title="title"></PageImage>
    </b-container>
    <div class="page-content">
        <slot></slot>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
const PageImage = () => import("@/components/page/PageImage");
const Header = () => import("@/components/common/Header");
const Footer = () => import("@/components/common/Footer");

export default {
    name: "Page",
    props: {
        "image": String,
        "title": String,
    },
    components: {
        PageImage,
        Header,
        Footer
    },
};
</script>
